import {
    useState,
    useRef,
    useEffect,
} from 'react'

import { useLocaleType } from '../contexts/Localization/localizationHooks'

export default function useTodaysDate(): string {
    const locale = useLocaleType()
    const [todaysDate, setTodaysDate] = useState(() => new Intl.DateTimeFormat(locale).format(new Date()))
    const timerRef = useRef(null)

    useEffect(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current)
        }
        timerRef.current = setInterval(() => {
            const currentDate = new Intl.DateTimeFormat(locale).format(new Date())

            if (currentDate !== todaysDate) {
                setTodaysDate(currentDate)
            }
        }, 1000)

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
            }
        }
    }, [locale, setTodaysDate])

    return todaysDate
}
